import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['template', 'target'];

  addRow(event) {
    event.preventDefault();

    const newIndex = Date.now().toString();
    const newRowHtml = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, newIndex);
    this.targetTarget.insertAdjacentHTML('beforebegin', newRowHtml);
  }

  async removeRow(event) {
    event.preventDefault();

    const wrapper = event.currentTarget.closest('.nested-form-wrapper');
    if (!wrapper) return;

    const reasonInput = wrapper.querySelector('input[name$="[reason]"]');
    if (!reasonInput) {
      wrapper.remove();
      return;
    }

    const currentReason = reasonInput.value.trim();
    const originalReason = (reasonInput.defaultValue || '').trim();

    this.clearError(wrapper);

    if (!currentReason) {
      this.showError(wrapper, "Reason can't be blank");
      reasonInput.focus();
      return;
    }

    if (currentReason === originalReason) {
      this.showError(wrapper, 'Reason needs to be updated');
      reasonInput.focus();
      return;
    }

    const confirmed = await this.requestConfirmation();
    if (!confirmed) return;

    const match = reasonInput.name.match(/\[(\w+_conditions)\]\[([^\]]+)\]\[reason\]/);
    if (match) {
      const [, conditionType, rowId] = match;
      this.appendRemovalReason(conditionType, rowId, currentReason);
    }

    wrapper.remove();
  }

  async requestConfirmation() {
    const mainEl = document.querySelector('main[data-controller~="confirm"]');
    const confirmCtrl = mainEl &&
      this.application.getControllerForElementAndIdentifier(mainEl, 'confirm');
    if (!confirmCtrl) return false;

    return confirmCtrl.request({
      title: 'Are you sure?',
      message: 'Are you sure you want to remove this row?',
      confirmButton: 'Remove',
      destructive: true,
    });
  }

  clearReasonError(event) {
    const wrapper = event.currentTarget.closest('.nested-form-wrapper');
    if (wrapper) this.clearError(wrapper);
  }

  appendRemovalReason(conditionType, rowId, reason) {
    const form = this.element.closest('form');
    if (!form) return;

    const name = `qc_setting[removal_reason_${conditionType}][${rowId}]`;
    let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = reason;
  }

  showError(wrapper, message) {
    const errorEl = wrapper.querySelector('[data-qc-settings-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.remove('hidden');
  }

  clearError(wrapper) {
    const errorEl = wrapper.querySelector('[data-qc-settings-error]');
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.classList.add('hidden');
  }
}
